module.exports = __webpack_public_path__ + "static/img/img-user.1784115679763.png";